import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api, errMsg, getGuestToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

function AuthForm({ mode, onDone }) {
  const [f, setF] = useState({ email: "", password: "", nome: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const body = mode === "login" ? { email: f.email, password: f.password } : f;
      const r = await api.post(`/auth/${mode}`, body);
      onDone(r.data);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={submit} className="space-y-3" data-testid={`${mode}-form`}>
      {mode === "register" && <Input data-testid="register-name-input" placeholder="Nome pubblico (classifica)" value={f.nome} onChange={set("nome")} required minLength={2} maxLength={30} />}
      <Input data-testid={`${mode}-email-input`} type="email" placeholder="Email" value={f.email} onChange={set("email")} required />
      <Input data-testid={`${mode}-password-input`} type="password" placeholder={mode === "register" ? "Password (min 8 caratteri)" : "Password"} value={f.password} onChange={set("password")} required minLength={mode === "register" ? 8 : 1} />
      {error && <p data-testid={`${mode}-error`} className="text-sm text-destructive">{error}</p>}
      <Button data-testid={`${mode}-submit-button`} disabled={busy} className="w-full rounded-full">{mode === "login" ? "Accedi" : "Crea account"}</Button>
    </form>
  );
}

export default function Login() {
  const { setUser } = useAuth();
  const nav = useNavigate();
  const onDone = async (u) => {
    setUser(u);
    if (getGuestToken()) toast.info("Puoi associare le scelte anonime di questo browser dal tuo profilo.");
    nav("/profilo");
  };
  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/profilo";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <div className="mx-auto max-w-md space-y-6">
      <h1 className="text-4xl font-bold">Accedi</h1>
      <p className="text-sm text-muted-foreground">La registrazione è facoltativa: serve per sincronizzare lo storico, ricevere notifiche ed entrare nella classifica ufficiale. Conserviamo solo email, nome pubblico e dati di gioco.</p>
      <div className="luma-card space-y-4">
        <Tabs defaultValue="login">
          <TabsList className="grid w-full grid-cols-2 rounded-full">
            <TabsTrigger value="login" data-testid="login-tab">Accedi</TabsTrigger>
            <TabsTrigger value="register" data-testid="register-tab">Registrati</TabsTrigger>
          </TabsList>
          <TabsContent value="login" className="pt-4"><AuthForm mode="login" onDone={onDone} /></TabsContent>
          <TabsContent value="register" className="pt-4"><AuthForm mode="register" onDone={onDone} /></TabsContent>
        </Tabs>
        <Button variant="outline" onClick={google} data-testid="google-login-button" className="w-full rounded-full">Accedi con Google</Button>
        <Link to="/" data-testid="continue-guest-link" className="block text-center text-sm text-muted-foreground hover:text-primary">Continua come ospite</Link>
      </div>
    </div>
  );
}
